
import multimode from "./Assets/multimode.jpg";
import "./CSS/modesGraphiques.scss"

export default function ModeGraphiques()
{
    return (
        <div className='Page'>
            <h1>Modes graphiques</h1>

            <p>
               Notez tout d'abord que dans toutes les notes et schémas où on je vous indique un bit d'incrustation, l'incrustation est non connectée. Ce bit est donc inutilisé sur VG5000 et seulement donné pour note.
            </p>

            <h2>Les modes</h2>

            <p>
                Nous avons donc differents modes:
            <ul>
                <li>Le mode 40 colonnes</li>
                <li>Le mode 80 colonnes</li>
            </ul>
            </p>

            <p>
                Chacun de ces modes existe sous différentes possibilités, à savoir un nombre de paramètres long et un court.<br/>
                Cependant le mode 40 colonnes a aussi un mode variable...
            </p>

            <p>
                Ce que cela signifie c'est simplement que tout ne sera pas forcément lu.<br/>
                A savoir que le nombre de paramètres ne sera pas le même et donc les possibilités plus ou moins réduites.<br/>
                Bien entendu nous détaillerons tout cela au fur et à mesure.
            </p>

            <h2>Les caractères</h2>

            <p>
                Dans tous les cas, un écran sera toujours composé de 25 lignes de caractères.<br/>
                Un caractère standard fera 8*10 pixels en mode 40 colonnes(attention j'ai bien précisé "standard", ce n'est pas toujours vrai selon le mode).<br/>
                Dans certains modes, la résolution peut changer et on se retrouvera avec des caractères de 5*10 par exemple en mode quadrichrome, ou 6*10 en mode 80 colonnes.
            </p>

            <p>
                Comme nous disposons de 5 bloc de VRAM contenants environ 100 caractères, vous pourrez donc en redéfinir environ 500 en plus des jeux de caractères déjà inclus à l'EF9345.
            </p>

            <h2>Les attributs</h2>

            <p>
                Pour chaque caractère à l'écran nous pourrons en général (pas toujours) lui définir des attributs.<br/>
                Les attributs sont les suivants:

                <ul>
                    <li>Doublement de la largeur du caractère</li>
                    <li>Doublement de la hauteur du caractère</li>
                    <li>Soulignement du caractère (selon le jeu de caractère)</li>
                    <li>Masquage du caractère (le caractère est rendu invisible selon l'état du masque actif ou inactif</li>
                    <li>Inversion des couleurs</li>
                    <li>Clignottement</li>
                </ul>
            </p>

            <p>
                Mettez bien évidement tout cela au conditionnel car selon le mode et le nombre de paramètres possibles, vous aurez le choix entre les uns, les autres, voir... aucuns.
            </p>

            <p>
                Notez aussi qu'il est tout à fait possible de changer de mode pendant l'affichage et d'avoir une ou plusieurs parties en 40 colonnes et une ou plusieurs en 80 colonnes, comme en témoigne 
                le screenshot si dessous. <br/>
                Il faudra bien entendu se synchroniser pour cela et comme vous le verrez plus tard, la stabilité n'est pas la première qualité de notre machine.
            </p>
            <p>
                <img className="multimode" src={multimode} alt="multimode" />
            </p>

            <p>
                Nous allons donc dans les chapitres suivants étudier ces différents modes, en commençant toujours pas le plus complet (long).
            </p>

        </div>
    )
}